import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useSessionStore } from '../stores/session'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: () => import('../views/CallbackView.vue'),
      meta: { public: true },
    },
    {
      path: '/select-workspace',
      name: 'select-workspace',
      component: () => import('../views/SelectWorkspaceView.vue'),
    },
    {
      path: '/',
      component: () => import('../views/AppLayout.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('../views/HomeView.vue'),
        },
        {
          path: 'documents',
          name: 'documents',
          component: () => import('../views/DocumentsView.vue'),
        },
        {
          path: 'documents/:id',
          name: 'document-detail',
          component: () => import('../views/DocumentDetailView.vue'),
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  if (to.meta.public) return true

  const auth = useAuthStore()
  if (!auth.isAuthenticated) {
    const { login } = await import('../services/auth')
    await login()
    return false
  }

  const session = useSessionStore()
  if (!session.selectedSupply && to.name !== 'select-workspace') {
    return { name: 'select-workspace' }
  }

  return true
})

export default router
